import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

const useWordcloudResults = (
  gameId?: string,
  slideId?: string,
  isNewWordcloud?: boolean,
  isAuthenticated?: boolean,
  refetchData?: boolean,
) => {
  const cacheKey = ['wordcloudresults', slideId, gameId];
  //TODO: @deprecated REMOVE isNewWordcloud
  const { data, isFetching, isLoading, error } = useQuery(
    cacheKey,
    () => {
      if (!slideId || !gameId) return Promise.resolve(undefined);
      if (isNewWordcloud) {
        if (isAuthenticated === false)
          return backendService.instance.game.retrievePublicWordcloud({
            gameId,
            slideId,
          });
        return backendService.instance.game.retrieveWordcloud({ gameId, slideId });
      }
      return backendService.instance.game.retrieveWordcloudResults({ gameId, slideId });
    },
    {
      enabled: Boolean(slideId) && Boolean(gameId),
      refetchInterval: refetchData ? 2000 : undefined,
    },
  );

  return {
    data,
    isFetching,
    isLoading,
    error,
    cacheKey,
  };
};

export default useWordcloudResults;
